import React, { Component } from 'react';
import { apiCalling } from "../apiService";
import { authHelper } from "../utilis/authHelper";
export default class HospitalDetails extends Component {

  constructor(props){
    super(props);

this.state={

  country:'',
  State:'',
  hospital:'',
  hospitalDetails:[],

}
}

componentDidMount(){

  const getDetails = {
    method: "POST",
    body: JSON.stringify({
      functionName: "getDoctorDetails",
      siteId: window.sessionStorage.getItem("siteId"),
      doctorId:authHelper.getUserId(),
    }),
  }
  apiCalling(getDetails).then((data) => {
    //console.log("hospitalDetails")
    if (data.success === "1") {        
      this.setState({  
        hospitalDetails:data.doctorData[0].hospitalDetails,
        // hospital: data.doctorData[0].hospitalDetails[0].name,
        // State: data.doctorData[0].hospitalDetails[0].state,
        // country: data.doctorData[0].hospitalDetails[0].country,
      });
    }
  });
//  let hospitalDetails=this.props.hospitalDetails 
//  hospitalDetails.map((obj)=>{
//   this.setState({country:obj[0].country});
//   this.setState({state:obj[0].state});
//   this.setState({hospital:obj[0].name});
// }) ;
}

  render() {
    return ( 
      <>
              {this.state.hospitalDetails.map((data) => (
               <div className='row'>
                  <div class="col-md-4 mb-3 mb-md-0">
                    <label className='label-text'>Country</label>
                    <input disabled="disabled" placeholder="Country" type="text" class="input-design" value={data.country} />
                  </div>
                  <div class="col-md-4 mb-3 mb-md-0">
                    <label className='label-text'>State</label>
                      <input disabled="disabled" placeholder="State" type="text" class="input-design"  value={data.state}/>
                  </div>
                  <div class="col-md-4 mb-0">
                    <label className='label-text'>Hospital</label>
                      <input disabled="disabled" type="text"  placeholder="Hospital" class="input-design" value={data.name} />
                  </div>
                </div>
                 ))}
                 </>
    )
  }
}
